import type { PagedRequestDto } from '../pagination/models';
import type { ServiceEntrySheetState } from './service-entry-sheet-state.enum';
import type { ErpResultDto } from '../erp-results/models';

export interface BasicResponseDto {
  isSuccess: boolean;
  message?: string;
}

export interface CreateServiceEntrySheetDto {
  periodId: number;
  orderLineIds: number[];
}

export interface GetServiceEntrySheetOrderLinesPagedRequestDto extends PagedRequestDto {
  serviceEntrySheetId: number;
}

export interface ServiceEntrySheetDetailsDto {
  id: number;
  periodName: string;
  state?: ServiceEntrySheetState;
  erpResult: ErpResultDto;
  purchaseOrderNumber: number;
  purchaseOrderLine: number;
  providerName: string;
  creationTime?: string;
}

export interface ServiceEntrySheetGridDto {
  id: number;
  number?: string;
  providerId: number;
  providerName: string;
  vendorName: string;
  periodName: string;
  purchaseOrderNumber: number;
  purchaseOrderLine: number;
  executionDate?: string;
  creationDate?: string;
  state?: ServiceEntrySheetState;
}

export interface ServiceEntrySheetPagedRequestDto extends PagedRequestDto {
  serviceEntrySheetId?: number;
  providerId?: number;
  vendorId?: number;
  periodId?: number;
  purchaseOrderNumber?: number;
  purchaseOrderLine?: number;
  serviceEntrySheetNumber?: string;
  dateFrom?: string;
  dateTo?: string;
  state?: ServiceEntrySheetState;
}

export interface ServiceEntrySheetResumeDto {
  totalUnits: number;
  unitOfMeasure: string;
  lineCount: number;
}
